import type { JSX } from "preact";
import { useEffect, useRef } from "preact/hooks";

type TextAreaProps = Omit<
  JSX.IntrinsicElements["textarea"],
  "class" | "autofocus"
> & {
  class?: string;
  wrapperClass?: string;
  autoGrow?: boolean;
  /** Focus the textarea when mounted (works for dynamically added elements) */
  autofocus?: boolean;
};

export function TextArea({
  autoGrow = true,
  autofocus,
  class: className,
  wrapperClass,
  value,
  placeholder,
  ...props
}: TextAreaProps) {
  const ref = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (autofocus) {
      ref.current?.focus();
    }
  }, [autofocus]);

  if (!autoGrow) {
    return (
      <textarea
        ref={ref}
        class={className}
        value={value}
        placeholder={placeholder}
        {...props}
      />
    );
  }

  const displayValue = value || placeholder || "";

  return (
    <div class={`autosize ${wrapperClass ?? ""}`}>
      <textarea
        ref={ref}
        class={`autosize-textarea ${className ?? ""}`}
        value={value}
        placeholder={placeholder}
        {...props}
      />
      <pre class={`autosize-pre ${className ?? ""}`}>
        {displayValue}
        <br />
      </pre>
    </div>
  );
}
